(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserDto', [UserDtoFn]);

    /* main user data transfer object for interacting with user objects */
    function UserDtoFn() {
        var UserDto = function () {
            // main attributes
            this.id = null;
            this.caption = null;
        };

        return UserDto;
    }
})();